module.exports = __webpack_public_path__ + "img/scan-w.71209977.svg";